import { Component, OnInit, Input } from '@angular/core';

// env
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html'
})
export class GalleryComponent implements OnInit {

  @Input() dataGallery;
  @Input() versi = '1';
  apiAsset = environment.API_ASSETS;
  
  constructor() { }

  ngOnInit(): void {
  }

}
